module.exports = __webpack_public_path__ + "static/img/Store-20.9a2c8d62.png";